import { DataBean } from "../DataBean";

export class PortfolioProductCapability extends DataBean {

  public async getPortfolioProductCapabilityCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getPortfolioProductCapabilityCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async updatePortfolioProductCapability(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.PortfolioProductCapability_updatePortfolioProductCapability_com.orange.finance.processcontract.bean.PortfolioProductCapability",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.PortfolioProductCapability",
        },
      ]
    );
  }
}
